import {renderFragment} from '../helpers/react-helpers'
import Icon from '../components/Icon'
import icons from '../../markons/markons'
import type { DataTableDefaultRenderer, DataTableProps} from '../components/datatable';
import {DataTable} from '../components/datatable'
import {InternalLink} from '../components/external-links'
import {NotSet} from '../components/table-links'
import React from 'react'
import {resolveRoute} from '../helpers/ajax'


const EditVehicleLink: DataTableDefaultRenderer<any> = ({data, row, meta, children}) => {
    const style = {
        maxWidth: meta.columnSettings.maxWidth,
        minWidth: meta.columnSettings.minWidth,
        width: meta.columnSettings.width,
    }
    return <InternalLink route="vehicles.edit"
        params={{id: row.id}}
        className="ellipsis"
        style={{...style, maxWidth: meta.columnSettings.maxWidth ?? meta.columnSettings.width}}>{children ||
        <NotSet />}</InternalLink>
}


export default function({isSuper, vehiclesUrl, canEditVehicles}: {
    isSuper: boolean,
    vehiclesUrl: string,
    canEditVehicles: boolean
}) {

    const dtOptions: DataTableProps = {
        defaultRender: EditVehicleLink,
        rowLink: data => resolveRoute('vehicles.edit', {id: data.id}),
        ajax: {url:vehiclesUrl},
        'columns': [
            {
                'title': 'Name',
                'data': 'name',
                // 'render': function (data, type, row) {
                //     return editVehicleLink({id: row.id, text: data});
                // },
                minWidth: '120px',
                // responsivePriority: 1,
            },
            {
                'title': 'Internal Name',
                'data': 'internal_name',
                // 'render': function (data, type, row) {
                //     return editVehicleLink({id: row.id, text: data});
                // },
                minWidth: '120px',
                // responsivePriority: 1,
            },
            {
                'title': 'Unit',
                // 'data': null,
                'className': 'tcenter',
                style: ({row}) => row.style,
                render: ({data, type, row:vehicle, meta}) => {
                    if(vehicle.code) {
                        return <InternalLink route="vehicles.edit" params={{id: vehicle.id}}
                            title={vehicle.name} style={vehicle.style}>{vehicle.code}</InternalLink>
                    }
                    return <InternalLink route="vehicles.edit" params={{id: vehicle.id}}><NotSet>TBD</NotSet></InternalLink>
                },
                width: '70px',
                // responsivePriority: 2,
            },
            {
                'title': 'Capacity',
                'data': 'capacity',
                className: 'tcenter',
                // 'render': function (data, type, row) {
                //     return editVehicleLink({id: row.id, text: data});
                // },
                width: '90px',
                // responsivePriority: 4,
            },
            {
                'title': 'Hourly',
                'data': 'hourly_rate',
                className: 'tright',
                width: '90px',
                // 'render': function (data, type, row) {
                //     return editVehicleLink({id: row.id, text: data});
                // },
                // // width: '120px',
                // responsivePriority: 5,
            },
            {
                'title': 'QF',
                'data': 'enabled_on_quote_form',
                className: 'tcenter',
                render: ({data: enabledOnQuoteForm}) => (
                    enabledOnQuoteForm ?
                        <Icon name={icons.faCheckCircle} className="payment--paid" /> :
                        <Icon name={icons.faTimesCircle} className="payment--unpaid" />
                ),
                // 'render': displayReact((enabledOnQuoteForm, type, row, meta) => {
                //     return <a href={Router.route('vehicles.edit', {id: row.id})}>{enabledOnQuoteForm ?
                //         <Icon name={icons.faCheckCircle} className="payment--paid"/> :
                //         <Icon name={icons.faTimesCircle} className="payment--unpaid"/>}</a>;
                // }),
                width: '65px',
                // responsivePriority: 5,
            },
            {
                'title': 'Aff.',
                'data': 'is_affiliate',
                className: 'tcenter',
                render: ({data: isAffiliate}) => (
                    isAffiliate ?
                        <Icon name={icons.faCheckCircle} className="payment--paid" /> :
                        <Icon name={icons.faTimesCircle} className="payment--unpaid" />
                ),
                // 'render': displayReact((isAffiliate, type, row, meta) => {
                //     return <a href={Router.route('vehicles.edit', {id: row.id})}>{isAffiliate ?
                //         <Icon name={icons.faCheckCircle} className="payment--paid"/> :
                //         <Icon name={icons.faTimesCircle} className="payment--unpaid"/>}</a>;
                // }),
                width: '65px',
                // responsivePriority: 5,
            }
        ],
        order: [['name', 'asc'], ['unit', 'asc']]
    }

    renderFragment(<DataTable {...dtOptions} />, '#vehicles-table')
}
